import { Box, Text, Textarea, VStack } from "@chakra-ui/react";
import { memo } from "react"
import { useParams } from "react-router-dom";
import { CircularLoading } from "../../molecules/loading/CircularLoading";
import { useFetchKuchikomyuSurveySelectedQuestionsCustomer } from "../../../hooks/kuchikomyu/useFetchKuchikomyuSurveySelectedQuestionsCustomer";
import { useAnswerKuchikomyuSurveyForm } from "../../../hooks/kuchikomyu/useAnswerKuchikomyuSurveyForm";
import { useSubmitKuchikomyuCustomerSurvey } from "../../../hooks/kuchikomyu/useSubmitKuchikomyuCustomerSurvey";
import { BlocksLogoForCustomerPostScoreForm } from "../../atoms/BlocksLogoForCustomerPostScoreForm";
import { CustomerPostScoreBtn } from "../../atoms/button/CustomerPostScoreBtn";
import { SurveyScoreRating } from "../../molecules/form/SurveyScoreRating";

export const AnswerKuchikomyuSurvey: React.FC = memo(() => {
  const params = useParams();
  const { restaurantId } = params;
  const { selectedQuestions, isLoading } = useFetchKuchikomyuSurveySelectedQuestionsCustomer(restaurantId!)

  if (isLoading) return <CircularLoading />
  if (!selectedQuestions) return null

  return (
    <Box p={4}>
      <AnswerForm restaurantId={restaurantId!} selectedQuestions={selectedQuestions} />
    </Box>
  );
});


type SelectedQuestions = {
  id: string;
  question: string;
  question_content: string;
}[]
const AnswerForm: React.FC<{restaurantId: string, selectedQuestions: SelectedQuestions }> = memo(({restaurantId, selectedQuestions}) => {
  const { handleSubmit, register, control, isSubmitting, errors } = useAnswerKuchikomyuSurveyForm()
  const onSubmit = useSubmitKuchikomyuCustomerSurvey(restaurantId!, selectedQuestions)
  return (
    <VStack as="form" onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data" spacing={4}>
      <BlocksLogoForCustomerPostScoreForm />
      {selectedQuestions.map((selectedQuestion, index) => (
        <SurveyScoreRating key={selectedQuestion.id} questionContent={selectedQuestion.question_content} index={index} control={control} errors={errors} />
      ))}
      <Box w='100%'>
        <Text as='label' fontSize='sm' >自由解答欄</Text>
        <Textarea rows={5} {...register('answer_text')} />
      </Box>
      <CustomerPostScoreBtn isSubmitting={isSubmitting} text='次へ'/>
    </VStack>
  );
});